export const mapFilterToResponse = (filters) => filters.map(({
  Id,
  EquipmentWithSpring,
  Selected,
}) => ({
  Id,
  EquipmentWithSpring,
  Selected: Selected ? 1 : 0,
}));

export const setDefaultFilters = (filters, defaultSelected = []) => (filters ? filters.map(({
  Id,
  EquipmentWithSpring,
  ...filter
}) => ({
  ...filter,
  Id,
  EquipmentWithSpring,
  Selected: defaultSelected.length
    ? defaultSelected.map((list) => list.id).indexOf(Id) !== -1
    : false,
})) : []);
